import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Footer = () => {
  return (
    <footer>
      <Container>
        <br />
        <Row>
          <Col className='text-center'>
            Copyright &copy; Hermanos Gazpachos Inc. 2026. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
